import {
  action,
  observable,
  runInAction,
} from 'mobx';
import RootStore from './root-store';
import logger from '../utils/logger';
import { ManualAdd } from '../../types/api/ManualAdd';

class ManualAddStore {
  rootStore: RootStore;

  @observable
    manualAddList: Array<ManualAdd> = [];
  @observable
    selectedManualAddId: number | null = null;
  @observable
    isLoading: boolean = false;
  @observable
    error: any = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  get api() {
    return this.rootStore.newAuthStore;
  }

  get locationId() {
    return this.rootStore.locationsStore.locationId;
  }

  @action
    selectManualAdd = (id: number) => {
      this.selectedManualAddId = id;
    };

  @action
    getManualAddById = (id: number | null) => {
      return this.manualAddList.find((data: ManualAdd) => data.extraProductItemId === id);
    };

  @action
    loadManualAddList = async () => {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.error = null;
      const url = `/api/batch/manual-add?locationId=${this.locationId}`;

      try {
        await this.api.storeDB.init();
        const localData = await this.api.storeDB.getByKey(url);

        runInAction(() => {
          if (localData) {
            this.manualAddList = localData;
          }
        });

        const serverData: any = await this.api.makeAuthorizedRequest(url);

        runInAction(() => {
          this.manualAddList = serverData;
        });
      } catch (error) {
        logger.error(error);
        runInAction(() => {
          this.error = error;
        });
      } finally {
        runInAction(() => {
          this.isLoading = false;
        });
      }
    };

  @action
    saveManualAdd = async (manualAdd: ManualAdd): Promise<void> => {
      await this.api.makeAuthorizedRequest(`/api/batch/manual-add?locationId=${this.locationId}`, {
        ...manualAdd,
      }, 'POST');
    };

  @action
    updateManualAdd = async (manualAdd: ManualAdd): Promise<void> => {
      await this.api.makeAuthorizedRequest(`/api/batch/manual-add/${manualAdd.id}?locationId=${this.locationId}`, {
        ...manualAdd,
      }, 'PUT');
    };

  @action
    removeManualAdd = async (id: number): Promise<void> => {
      await this.api.makeAuthorizedRequest(`/api/batch/manual-add/${id}?locationId=${this.locationId}`, {}, 'DELETE');
    };
}

export default ManualAddStore;
